export default __webpack_public_path__ + "static/media/Flag_of_Mauritius.e3207be0.svg";